import { useCallback } from "react";
import useLocalStorageState from "use-local-storage-state";

import { MUTED } from "../constants/localStorage";

export default function useSound() {
  const [muted, setMuted] = useLocalStorageState(MUTED, {
    defaultValue: false,
  });

  const muteSound = useCallback(() => {
    setMuted(!muted);
  }, [muted]);

  const playSound = useCallback(
    async (audio: HTMLAudioElement) => {
      try {
        if (!muted) {
          await audio.play();
        }
      } catch (e) {
        console.error(e);
      }
    },
    [muted]
  );

  return { playSound, muteSound, muted };
}
